import { testimonials } from '../../../mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-slate-50 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Reviews
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-4">
            What South Florida Homeowners Say
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-orange-400 text-lg"></i>
              </div>
            ))}
            <span className="text-slate-600 text-sm font-semibold ml-1">5.0 Average Rating</span>
          </div>
          <p className="text-slate-500 text-base">100+ verified 5-star reviews across South Florida</p>
        </div>

        {/* Testimonial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <article
              key={t.id}
              className="bg-white border border-gray-200 rounded-2xl p-6 border-l-4 border-l-teal-500 flex flex-col"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-orange-400 text-sm"></i>
                  </div>
                ))}
              </div>

              {/* Review Text */}
              <blockquote className="text-slate-600 text-sm leading-relaxed italic flex-1 mb-5">
                &ldquo;{t.text}&rdquo;
              </blockquote>

              {/* Reviewer */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-teal-100">
                  <i className="ri-user-3-fill text-teal-600 text-lg"></i>
                </div>
                <div>
                  <p className="font-bold text-slate-800 text-sm">{t.name}</p>
                  <p className="text-slate-400 text-xs">{t.service} · {t.location}</p>
                </div>
                <div className="ml-auto">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-teal-50">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-base"></i>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <p className="text-slate-500 text-sm mb-4">Join hundreds of happy South Florida homeowners</p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-bold px-7 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-heart-fill text-teal-200 text-base"></i>
            </div>
            Get Your Free Estimate Today
          </a>
        </div>
      </div>
    </section>
  );
}
